import { styled } from "styled-components";

import { LandingCarousel } from "domains/landing/components/StyledLandingCarousel";
import { StyledLandingText } from "domains/landing/components/StyledLandingText";
import { StyledLandingTitle } from "domains/landing/components/StyledLandingTitle";
import { TopicTile } from "domains/topic/components/topicTile/TopicTile";
import type { Topic } from "entities/topics/types";

const ITEM_WIDTH = 300;

const StyledContainer = styled.div`
  max-width: 1600px;
  box-sizing: border-box;
  width: 100%;
`;

const StyledContent = styled.div<{ isLoaded: boolean }>`
  transition: opacity 1s ease-in-out;
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
`;

const StyledCard = styled.div<{ index: number; isLoaded: boolean }>`
  width: ${ITEM_WIDTH}px;
  padding-right: 20px;
  border-radius: 10px;
  flex-shrink: 0;
  scroll-snap-align: start;
  transition: opacity 1s ease-in-out ${({ index = 0 }) => 0.3 + 0.1 * index}s;
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
`;

const StyledText = styled(StyledLandingText)`
  margin: 0;
`;

type TopicSliderProps = { isLoaded: boolean; message?: string; title: string; topics: Topic[] };

export const TopicSlider = ({ isLoaded, message, title, topics }: TopicSliderProps) =>
  topics.length > 0 ? (
    <StyledContainer>
      <StyledContent isLoaded={isLoaded}>
        <StyledLandingTitle>{title}</StyledLandingTitle>
        <StyledText>{message}</StyledText>
      </StyledContent>
      <LandingCarousel count={topics.length} isLoaded={isLoaded} itemWidth={ITEM_WIDTH}>
        {topics.map((topic, index) => (
          <StyledCard key={topic.id} isLoaded={isLoaded} index={index}>
            <TopicTile
              key={topic.id}
              topicId={topic.id}
              topicName={topic.name}
              provider={topic.provider}
              topicBack={{ term: "app.home" }}
              attachment={topic.attachment ?? undefined}
              canEdit={topic.can_edit ?? false}
              isCustom={topic.is_custom ?? false}
              isNew={topic.is_new ?? false}
              isFollowing={topic.is_following ?? false}
              imageUrl={topic.images?.x_small}
            />
          </StyledCard>
        ))}
      </LandingCarousel>
    </StyledContainer>
  ) : null;
